(function($) {
Drupal.behaviors.civicontrib = {
  attach: function (context, settings) {
    $('label[for="start_date"]').hide();
    $('#pledge_installments_num').hide();
    if($(".price-set-option-content input[type='radio']:not([data-amount]").is(':checked')) {
      $( ".other_amount-section" ).show();
    } else {
      $( ".other_amount-section" ).hide();
      $( ".other_amount-section input" ).val('');
    }
    $(".price-set-option-content input").click(function() {
      if($(".price-set-option-content input[type='radio']:not([data-amount]").is(':checked')) {
        $( ".other_amount-section" ).show(100);
      } else {
        $( ".other_amount-section" ).hide(100);
        $( ".other_amount-section input" ).val('');
      }
    });
    if($("input#CIVICRM_QFID_1_is_pledge").is(':checked')) {
      $( "#pledge_frequency_unit" ).show();
      $( "#CIVICRM_QFID_3_payment_processor_id" ).hide();
      $('label[for="CIVICRM_QFID_3_payment_processor_id"]').hide();
      $( "#CIVICRM_QFID_1_payment_processor_id" ).hide();
      $('label[for="CIVICRM_QFID_1_payment_processor_id"]').hide();
      $( "#CIVICRM_QFID_0_payment_processor_id" ).hide();
      $('label[for="CIVICRM_QFID_0_payment_processor_id"]').hide();
    } else {
      $( "#pledge_frequency_unit" ).hide();
      $( "#CIVICRM_QFID_3_payment_processor_id" ).show();
      $('label[for="CIVICRM_QFID_3_payment_processor_id"]').show();
      $( "#CIVICRM_QFID_1_payment_processor_id" ).show();
      $('label[for="CIVICRM_QFID_1_payment_processor_id"]').show();
      $( "#CIVICRM_QFID_0_payment_processor_id" ).show();
      $('label[for="CIVICRM_QFID_0_payment_processor_id"]').show();
    }
    $(".is_pledge-section input").click(function() {
      if($("input#CIVICRM_QFID_1_is_pledge").is(':checked')) {
        $( "#pledge_frequency_unit" ).show(100);
        $( "#CIVICRM_QFID_3_payment_processor_id" ).hide(100);
        $('label[for="CIVICRM_QFID_3_payment_processor_id"]').hide(100);
        $( "#CIVICRM_QFID_1_payment_processor_id" ).hide(100);
        $('label[for="CIVICRM_QFID_1_payment_processor_id"]').hide(100);
        $( "#CIVICRM_QFID_0_payment_processor_id" ).hide(100);
        $('label[for="CIVICRM_QFID_0_payment_processor_id"]').hide(100);
      } else {
        $( "#pledge_frequency_unit" ).hide(100);
        $( "#CIVICRM_QFID_3_payment_processor_id" ).show(100);
        $('label[for="CIVICRM_QFID_3_payment_processor_id"]').show(100);
        $( "#CIVICRM_QFID_1_payment_processor_id" ).show(100);
        $('label[for="CIVICRM_QFID_1_payment_processor_id"]').show(100);
        $( "#CIVICRM_QFID_0_payment_processor_id" ).show(100);
        $('label[for="CIVICRM_QFID_0_payment_processor_id"]').show(100);
      }
    });

    // remove label from contribution amount

    //change position buttons in contribution confirmation screen
    $(".crm-button-type-back:last").insertBefore(".crm-button-type-next");
  }
};
})(jQuery);
